module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _vm._l((_vm.getChunked()), function(chunk) {
    return _c('div', {
      key: chunk + Math.random(),
      staticClass: "columns"
    }, _vm._l((chunk), function(player) {
      return _c('div', {
        key: player.id,
        staticClass: "column is-3 player-box"
      }, [_c('div', {
        on: {
          "click": function($event) {
            return _vm.onClick(player.id)
          }
        }
      }, [_c('img', {
        staticClass: "team_logo image is-64x64 has-image-centered",
        attrs: {
          "src": _vm.logo
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "title has-text-centered"
      }, [_vm._v("#" + _vm._s(player.number))]), _vm._v(" "), _c('p', {
        staticClass: "title has-text-centered"
      }, [_vm._v(_vm._s(player.forename) + " "), _c('br'), _vm._v(_vm._s(player.surname))])])])
    }), 0)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37652b21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/playerCard.vue
// module id = 604
// module chunks = 30